<template>
  <div
    class="quick-search"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    :id="id"
    v-scroll-to="{
      el: `${scrollId}`,
      container: '#scroll-block',
      offset: -50,
      onStart: onStart,
      onDone: onDone,
    }"
  >
    <div v-if="showSelected" class="quick-search__selected">
      <Tag
        v-for="(i, index) in selectedItems"
        :key="`${id}-selected-${index}`"
        class="tag--capitalize"
        :class="{ 'tag--selected': i.selected }"
        :value="i.title"
        :close="true"
        @deleteTag="selectFilter(i)"
      ></Tag>
    </div>
    <div class="quick-search__input" :class="{ 'quick-search__input--loading': loading }">
      <input
        required
        type="text"
        v-model="item"
        @input="searchMatches"
        @keyup.enter.prevent="createItem"
        @focus="focusOpen ? searchMatches() : false"
        @focusin="focus = true"
        @focusout="focus = false"
        :disabled="disabled"
      />
      <label class="quick-search__label">
        {{ placeholder }}
        <span class="quick-search__label_required" v-if="required">*</span>
      </label>
    </div>
    <div class="quick-search__match" v-if="open">
      <div class="quick-search__match_body">
        <template v-if="matches.length">
          <ul>
            <li
              v-for="(match, index) in matches"
              :key="`${id}-match-${index}`"
              @click.prevent="selectFilter(match)"
            >
              <p class="quick-search__match_item">{{ match.title }}</p>
              <span class="quick-search__match_icon">
                Add
                <IconButton class="button--xs button--outline-blue">
                  <IconPlus width="12" height="12"></IconPlus>
                </IconButton>
              </span>
            </li>
          </ul>
        </template>
        <h6 v-else>No Results Found</h6>
      </div>
    </div>
    <p class="quick-search__error">{{ validateError }}</p>
  </div>
</template>
<script>
import IconLoader from "@/components/icons/IconLoader.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import IconPlus from "@/components/icons/IconPlus.vue";
import Tag from "@/components/Tag.vue";
import IconCloseBold from "@/components/icons/IconCloseBold";
import IconMoveDots from "@/components/icons/IconMoveDots";

export default {
  props: {
    id: { type: String, default: "quick-search" },
    creating: { type: Boolean, default: true },
    focusOpen: { type: Boolean, default: false },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: { type: String },
    loading: { type: Boolean, default: false },
    matches: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    validateError: { type: String, default: "" },
    showSelected: { type: Boolean, default: false },
  },
  components: { IconLoader, IconButton, IconPlus, Tag, IconCloseBold, IconMoveDots },
  data() {
    return {
      item: "",
      selectedItems: [],
      open: false,
      focus: false,
      cursorEnter: false,
      scrollId: "",
      canClose: true,
      orderedItems: [],
    };
  },
  created() {
    this.selectedItems = this.items;
    // this.orderedItems = JSON.parse(JSON.stringify(this.items));
    // this.sortable(this.items);
    this.scrollId = `#${this.id}`;
  },
  watch: {
    items(val) {
      this.selectedItems = val;
    },
    open(val) {
      if (!val) {
        this.item = "";
        this.$emit("searchMatches", { search: "", excludeIdx: this.selectedItems });
      }
    },
    focus(val) {
      if (!val && !this.cursorEnter) {
        this.open = false;
      }
    },
  },
  methods: {
    selectFilter(item) {
      let selectedItems = this.selectedItems;
      let newEl = true;
      if (selectedItems.length) {
        for (let el of selectedItems) {
          if (+el.id === +item.id && el.title === item.title) {
            newEl = false;
            break;
          }
        }

        if (newEl) selectedItems.push(item);
        // else {
        //   selectedItems = selectedItems.filter(i => {
        //     return i.id != item.id || i.title !== item.title;
        //   });
        // }
      } else {
        selectedItems.push(item);
      }
      this.selectedItems = selectedItems;
      this.$emit("selectItem", this.selectedItems);
      this.$emit("searchMatches", { search: this.item, excludeIdx: this.selectedItems });
    },
    searchMatches() {
      this.$emit("searchMatches", { search: this.item, excludeIdx: this.selectedItems });
      this.open = true;
    },
    sortable(items) {
      // let type = this.artistName;
      let orderedItems = JSON.parse(JSON.stringify(items));
      orderedItems = orderedItems
        // .filter(el => {
        //   return el.artist_name === type;
        // })
        .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
      this.selectedItems = orderedItems;
    },
    createItem() {
      if (this.creating) {
        this.$emit("addItem", this.item);
        this.item = "";
      }
    },
    mouseenter() {
      this.cursorEnter = true;
    },
    mouseleave() {
      if (this.canClose && !this.focus) {
        this.open = false;
      }
      this.cursorEnter = false;
    },
    onStart() {
      this.canClose = false;
    },
    onDone() {
      this.canClose = true;
      this.open = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.quick-search {
  position: relative;
  width: 100%;
  &__input {
    position: relative;
    margin-top: 10px;
    input {
      height: 9rem;
      padding: 0 15.5rem 0 2.7rem;
      border: 0.5px solid $lightGrey;
      border-radius: 12px;
      @include type();
      color: $lightBlack;
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        height: 7rem;
        font-size: 14px;
      }
    }
    &--loading {
      input {
        padding-right: 20rem;
      }
    }
  }
  &--invalid {
    .quick-search__input input {
      border-color: $error;
    }
  }
  &__icon {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    @include type($fw: 500);
    cursor: pointer;
    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
      font-size: 14px;
    }

    &--loading {
      right: 16.5rem;
      cursor: default;
    }
    &--single {
      right: 15px;
    }
    &--disabled {
      opacity: 0.6;
      pointer-events: none;
    }
    .button {
      margin-left: 10px;
    }
  }
  &__label {
    position: absolute;
    @include type($fw: 500);
    color: $lightBlack;
    top: 50%;
    left: 2.4rem;
    transform: translateY(-50%);
    padding: 1px 1.1rem;
    background-color: $white;
    transition: all 0.1s ease;
    pointer-events: none;
    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
      font-size: 14px;
    }
    &_required {
      display: inline-block;
      font-size: 18px;
      font-weight: 600;
      color: $error;
      margin-left: 4px;
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      }
    }
  }
  input:focus ~ &__label,
  input:valid ~ &__label {
    top: 0;
  }
  &__selected {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    &:empty {
      margin-top: 0;
    }
    &-body {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 20px;
      row-gap: 20px;
      margin-top: 15px;
    }
    &-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-width: 22.8rem;
      min-height: 22rem;
      border: 0.5px solid #bcbcbc;
      border-radius: 12px;
      padding: 12px 12px;
      background: $white;
      cursor: pointer;
      img {
        height: 100%;
        width: 100%;
        border-radius: 7px;
      }
      p {
        width: 100%;
        text-align: left;
        margin-top: 5px;
        @include type($fs: 14px, $fw: 600);
        color: $black;
      }
      &_container {
        position: absolute;
        top: 22px;
        right: 22px;
        padding: 0;
        border-radius: 5px;
        height: 26px;
        width: 26px;
        background-color: $white;
        &--close {
        }
        &--reorder {
          right: 56px;
          padding: 5px;
        }
      }
      &_svg {
        /* height: 12px;
        width: 12px; */
      }
    }
  }
  &__match {
    position: absolute;
    bottom: 0;
    transform: translateY(100%);
    width: 100%;
    z-index: 9;
    padding-top: 11px;
    &--image {
      top: 10rem;
      transform: translateY(0);
      bottom: auto;
    }
    &_body {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.24);
      padding: 24px 22px 16px;
      max-height: 300px;
      overflow-y: auto;
      border: 1px solid #efefef;
    }
    &_title {
      @include type($fw: 700);
      text-transform: capitalize;
      margin-bottom: 25px;
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      }
    }
    &_item {
      @include type();
      color: $black;
      text-align: left;
      padding: 6px 2rem;
      margin-bottom: 8px;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        color: $blue;
      }
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      }
    }

    h6 {
      @include type($fw: 500);
      color: rgba($color: #111111, $alpha: 0.7);
      margin-bottom: 15px;
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      }
    }
    &_icon {
      display: flex;
      align-items: center;
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
      @include type($fw: 500, $fs: 14px);
      cursor: pointer;
      /* @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      } */

      &--loading {
        right: 16.5rem;
        cursor: default;
      }
      &--single {
        right: 15px;
      }
      &--disabled {
        opacity: 0.6;
        pointer-events: none;
      }
      .button {
        margin-left: 10px;
      }
    }
  }
  &__error {
    position: absolute;
    @include type($fs: 12px, $fw: 500);
    color: $error;
    padding-top: 3px;
  }
}
</style>
